import { useEffect } from "react";
import "./App.css";
import { useRecoilState } from "recoil";
import { getMydata } from "./actions/Login";
import { accountAtom } from "./modules/Login/atoms/AccountAtom";
import history from "./utils/History";
import { Redirect, Route, Router, Switch } from "react-router-dom";
// import VendorSecurityQuestionnaireForm from "modules/CarrierAgreementMgmt/Vendor/forms/VendorSecurityQuestionnaireForm";
import Routes from "routes";

function App() {
  const [, setAccount] = useRecoilState(accountAtom);

  const getAccount = async () => {
    const res = await getMydata();
    if (res && res.status === 200) {
      return res;
    } else {
      history.push("/");
    }
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const token = url.searchParams.get("token");
    const username = url.searchParams.get("username");
    if (token && username) {
      localStorage.setItem("token", token);
      localStorage.setItem("username", username);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && token !== "null") {
      getAccount().then((res) => {
        if (res) {
          const { data } = res;
          setAccount({ ...data, token });
        }
      });
    }
  }, [setAccount]);

  return (
    <Router history={history}>
      <Switch>
        {/* <Route
          path={`/vendorSecurityQuestionnaire`}
          component={VendorSecurityQuestionnaireForm}
        /> */}
        <Route path="/" component={Routes} />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}

export default App;
